import { render, staticRenderFns } from "./Login-old.vue?vue&type=template&id=749adde2&scoped=true&"
import script from "./Login-old.vue?vue&type=script&lang=js&"
export * from "./Login-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749adde2",
  null
  
)

export default component.exports